export default __webpack_public_path__ + "images/AV.042186b.png";